import type { Store } from "redux";
import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "../../../client/reducers";
import createInitialState from "../../../client/createInitialState";
import { bindActions } from "../../../client/containers";

export const createEnhancedStore = (
  reducer: (...args: Array<any>) => any,
  initialState: Record<string, any>,
): Store => {
  // eslint-disable-next-line no-underscore-dangle
  const enhancers = applyMiddleware(thunkMiddleware);
  const enhancedStoreCreator = composeWithDevTools(enhancers)(createStore);
  return enhancedStoreCreator(reducer, initialState);
};

export const initialState = createInitialState();
const store = createEnhancedStore(rootReducer, initialState);

export const actions = bindActions(store);

export default store;
